import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { FlashMessagesService } from "angular2-flash-messages";
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { CommonService } from "../../_services/common.service";
import { InkColorPickerComponent } from '../ink-color-picker/ink-color-picker.component';

export interface DialogData {
  inkColors: any;
  active_artwork_loc: string;
  selectedInkColor: any;
  selectedInkColorObj: any;
  projects: any;
  activeProjectIndex: any;
  active_location_arr: any;
  artworkPrintOpt: any,
  selectedAdons: any,
  maxInkLength: number,
  section: string,
  artworkHexColors: any,
  otherPrintSettings: any,
  activeStep: any,
  url: any,
  artwork_img: any,
}

@Component({
  selector: 'app-pf-artfile',
  templateUrl: './pf-artfile.component.html',
  styleUrls: ['./pf-artfile.component.css']
})

export class PfArtfileComponent implements OnInit {
  public t = 0;
  public onImagePreview = false;
  public imgWidth = 0;
  public imgHeight = 0;
  public isUploading = false;
  public isArtworkLoaded = false;
  public artworkFiles = [];
  public artworkSrc = null;
  public imp_upload_error = null;
  public artwork_img = null;
  public selectedFile = null;
  public src = null;
  public isShowAssign = false;
  public imageUrl: string;
  private cx: CanvasRenderingContext2D;
  private tempProjectData: any = {};
  public invoiceFiles: Array<any> = [];
  @ViewChild("canvas") canvas;
  //priceMatrixList:Array<any>=[];
  public activeProjectIndex = "";
  public projects: any = {};
  public artworkHexColors: any = {};
  public activeLocationArr = [];


  constructor(public dialogRef: MatDialogRef<PfArtfileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _flashMessagesService: FlashMessagesService,
    private CommonProjectDataService: CommonProjectDataService,
    private CommonService: CommonService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.activeProjectIndex = this.CommonProjectDataService.getActiveProjectIndex();
    this.projects = JSON.parse(JSON.stringify(this.CommonProjectDataService.get()));
    this.artworkHexColors = this.projects.projects_data[this.activeProjectIndex]["artwork"] ? this.projects.projects_data[this.activeProjectIndex]["artwork"] : {};
    this.activeLocationArr = this.projects.projects_data[this.activeProjectIndex]["active_location_arr"] ? this.projects.projects_data[this.activeProjectIndex]["active_location_arr"] : [];

    if (this.data.projects.user_id && this.data.projects.user_id != null && this.data.projects.user_id != '')
      this.getInvoiceFiles();
  }

  ngAfterViewInit() {
    if (this.activeLocationArr.length > 0) {
      this.activeLocationArr.forEach((cval, ckey) => {
        if (this.artworkHexColors[cval.emblocation_id] && this.artworkHexColors[cval.emblocation_id].img_ext_path) {
          this.displayCanvasImage(this.artworkHexColors[cval.emblocation_id].img_ext_path, '', cval.emblocation_id, 0);
        }
      });
    }
    // this.displayCanvasImage(this.data.url, '', '', 0);
  }

  onNoClick(): void {
    this.artworkFiles = [];
    this.dialogRef.close(this.data.url);
  }

  displayCanvasImage(url, artFileType, location, index) {
    this.isShowAssign = false;
    this.imageUrl = url;
    let urlExt = url.split(".").pop().toLowerCase();
    if (['ai', 'eps', 'pdf', 'tiff', 'tif', 'zip', 'cdr', 'ps'].indexOf(urlExt) !== -1) {
      url = 'assets/img/' + urlExt + '.png';
    }
    else {
      url
    }

    let obj = this;
    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
    this.cx = canvasEl.getContext('2d');
    let image = new Image();
    image.src = url;
    image.onload = function () {

      canvasEl.width = 500;
      canvasEl.height = 480;

      let imageAspectRatio = image.width / image.height;
      let canvasAspectRatio = canvasEl.width / canvasEl.height;
      let renderableHeight = image.height;
      let renderableWidth = image.width;
      let xStart = (canvasEl.width - image.width) * 0.5;
      let yStart = (canvasEl.height - image.height) * 0.5;

      // If image's aspect ratio is greater than canvas's we fit on width
      // and place the image centrally along height

      if (image.width >= canvasEl.width) {
        renderableWidth = canvasEl.width - 50;
        renderableHeight = image.height * (renderableWidth / image.width);
        xStart = (canvasEl.width - renderableWidth) / 2;
        yStart = (canvasEl.height - renderableHeight) / 2;
      }
      if (image.height > canvasEl.height) {
        renderableHeight = canvasEl.height;
        renderableWidth = image.width * (renderableHeight / image.height);
        xStart = (canvasEl.width - renderableWidth) / 2;
        yStart = 0;
      }

      obj.cx.drawImage(image, xStart, yStart, renderableWidth, renderableHeight);
    }

  }

  isArtworkValidated(artwork_img, artwork_hex_colors, active_artwork_loc) {
    let rtData = (artwork_img && artwork_hex_colors[active_artwork_loc] && artwork_hex_colors[active_artwork_loc].img_ext_path) ? true : false;
    return rtData;
  }

  isArtworkImgFileValid(artwork_hex_colors, active_artwork_loc) {
    return (artwork_hex_colors[active_artwork_loc] && artwork_hex_colors[active_artwork_loc].img_ext_path) ? true : false;
  }

  validateArtColor(artwork_hex_colors, active_artwork_loc) {
    return artwork_hex_colors && artwork_hex_colors[active_artwork_loc] && artwork_hex_colors.img_ext_path ? false : true;
  };

  addPosition(printPostion, loc) {
    let printPosition = JSON.parse(JSON.stringify(this.data.artworkPrintOpt[loc].locationSetting[this.data.otherPrintSettings[loc].placementIndex]['printPositions'].find(x => x.name === printPostion)));
    if (printPosition) {
      this.data.otherPrintSettings[loc].priceMatrix = printPosition.matrixData.find(x => x.is_default == '1');
      //this.data.priceMatrixList=printPosition.matrixData;
      this.data.otherPrintSettings[loc]['printPosition'].print_position_id = printPosition.print_position_id;
    }
    else {
      this.data.otherPrintSettings[loc]['printPosition'] = { print_position_id: '', name: '' };
    }

  }

  setActiveLocation(locs, section, steptype) {

    this.data.active_artwork_loc = locs;
    //this.activeSection = section;
    this.data.activeStep = steptype;
    if (section == "inkcolor") {

      if (steptype == 'stepone' || steptype == 'steptwo') {
        //angular.element('#art-manager').css('overflow', 'hidden');
        //angular.element('body').css('overflow', 'hidden');
      }

      if (!(this.data.selectedAdons[locs] && this.data.selectedAdons[locs][this.data.artworkPrintOpt[locs].addOns[0].add_on_id])) {
        this.data.selectedAdons[locs] = {
          [this.data.artworkPrintOpt[locs].addOns[0]['add_on_id']]: new Array(this.data.artworkPrintOpt[locs].addOns[0].number_of_input_box).fill(null)
        };
      }
      this.showInkColorPicker(section);

    }

  }

  showInkColorPicker(section) {
    const dialogRef = this.dialog.open(InkColorPickerComponent, {
      width: "90%",
      maxWidth: "none",
      disableClose: true,
      data: {
        inkColors: this.data.inkColors,
        active_artwork_loc: this.data.active_artwork_loc,
        selectedInkColor: this.data.selectedInkColor,
        selectedInkColorObj: this.data.selectedInkColorObj,
        projects: this.data.projects,
        activeProjectIndex: this.data.activeProjectIndex,
        active_location_arr: this.data.active_location_arr,
        artworkPrintOpt: this.data.artworkPrintOpt,
        selectedAdons: this.data.selectedAdons,
        maxInkLength: this.data.maxInkLength,
        section: section,
        activeStep: this.data.activeStep,
        artworkHexColors: this.data.artworkHexColors,
        otherPrintSettings: this.data.otherPrintSettings

      }
    });
    // dialogRef.afterClosed().subscribe(result => {
    //   console.log('Selected Ink color picker',this.data.selectedInkColorObj);
    //   console.log('projectDataprintart',this.data.projects.projects_data[this.data.activeProjectIndex]);
    //   // this.data.projects.projects_data[this.data.activeProjectIndex]["inkColorObj"] =
    //   //   Object.assign({}, this.data.selectedInkColorObj);
    //   // this.data.projects.projects_data[this.data.activeProjectIndex]["inkColors"] =
    //   //   Object.assign({}, this.data.selectedInkColor);
    //   //this.processAddonData();
    //   //this.tempProjectData = JSON.parse(JSON.stringify(this.data.projects.projects_data));
    //   //this.getPrice(this.tempProjectData);


    // });
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  isPrintSettingUpdated(locs) {

    let otherData = this.data.otherPrintSettings[locs];
    if (otherData.printWidth && otherData.printDistance && otherData.printPosition.name) {
      return true;
    }
    else {
      return false;
    }
    // if(idx($scope.otherPrintSettings, _ => _[locs].printWidth) && idx($scope.otherPrintSettings, _ => _[locs].printDistance) && idx($scope.otherPrintSettings, _ => _[locs].printPosition)){
    //   return true;
    // }
    // else
    // {
    //   return false;
    // }
  }

  isAddonSelected(addon) {
    let adSelected = 0;
    if (addon) {
      let objKey = Object.keys(addon);
      let objVal = addon[objKey[0]];
      Object.keys(objVal).forEach((key) => (objVal[key] == null || objVal[key] == '') && delete objVal[key]);
      adSelected = Object.keys(objVal).length;
    }
    return (adSelected > 0) ? true : false;
  }

  resetArtwork(activeLocs) {

    this.data.activeStep = 'steptwo';
    this.data.active_artwork_loc = activeLocs;
    this.data.section = 'artwork';
    this.artworkFiles = [];
    if (!this.isArtworkLoaded) {
      this.deleteFile(this.data.artworkHexColors[activeLocs].img_ext_path, this.data.artworkHexColors[activeLocs].org_file_ext_path, this.data.artworkHexColors[activeLocs].active_uui);
    }

    this.artworkSrc = null;
    this.imp_upload_error = null;
    //this.data.noOfColor = 4;
    this.artwork_img = null;
    //this.data.img_name = null;
    //this.files = null;
    this.src = null;
    // this.isOpenColorReplacer = false;

    //$scope[activeLocs + "_artwork_src"] = null;
    // if($scope.isArtworkLoaded){
    delete this.data.selectedInkColorObj[activeLocs];
    // delete $scope.artwork_hex_colors[activeLocs];
    this.data.artworkHexColors[activeLocs] = {};
    delete this.data.selectedInkColor[activeLocs];
    // }
    this.data.projects.projects_data[this.data.activeProjectIndex]["artwork"] = Object.assign({}, this.data.artworkHexColors);

    this.data.projects.projects_data[this.data.activeProjectIndex]["inkColorObj"] = this.data.selectedInkColorObj;
    this.data.projects.projects_data[this.data.activeProjectIndex]["inkColors"] = this.data.selectedInkColor;
    this.dialogRef.close('');

  }

  getInvoiceFiles = function () {
    let options = {
      'id': localStorage.getItem("userID"),
      'user_id': this.data.projects.user_id
    }
    this.CommonService.apiService(
      "POST",
      "invoices/files",
      options
    ).subscribe(
      (response: any) => {
        //this.loading = false;
        if (response.status === true) {
          if (response.data) {
            this.invoiceFiles = response.data
          }
        }
      },
      err => {
        //this.loading = false;
        console.log(err);
      }
    );
  }

  isDisplayFolderData(artworkFiles) {
    let compactArray = artworkFiles.filter(function (item) {
      return item.colors;
    });
    return (compactArray.length > 0) ? false : true;
  }

  displayFolderData = function (artworkFiles) {
    this.artworkFiles = artworkFiles;

  }

  setBgStatusClass(iStatus) {
    let statusClass = {
      'Mockups Submitted': 'yellow',
      'Garments Ordered': 'yellow',
      'Ship | Local Pickup': 'yellow',
      'Print Production': 'pink',
      'Complete': 'pink',
      'Cancel': 'pink',
      'Assign': 'blue',
      'Generate Mockups': 'blue',
      'Order Queue': 'blue'
    };
    return statusClass[iStatus] + '-bg';
  }

  loadArtwork(artworkData, imageUrl) {
    let tmpartworkData = artworkData;
    if (tmpartworkData.colors && tmpartworkData.colors.other_data) {
      this.isArtworkLoaded = true;
      delete this.data.selectedInkColorObj[this.data.active_artwork_loc]
      //delete this.data.inkChangeData[$scope.active_artwork_loc]
      delete this.data.selectedInkColor[this.data.active_artwork_loc]
      this.data.selectedInkColorObj[this.data.active_artwork_loc] = tmpartworkData.colors.other_data.new_hex_obj;
      this.data.selectedInkColor[this.data.active_artwork_loc] = tmpartworkData.colors.other_data.new_color_id;
      this.data.artworkHexColors[this.data.active_artwork_loc].img_ext_path = tmpartworkData.colors.other_data.updated_file_ext;
      delete this.data.artworkHexColors[this.data.active_artwork_loc].replacecoloropt;

      this.data.projects.projects_data[this.data.activeProjectIndex]["inkColorObj"] = this.data.selectedInkColorObj;
      this.data.projects.projects_data[this.data.activeProjectIndex]["inkColors"] = this.data.selectedInkColor;

    }
    if (tmpartworkData.colors && tmpartworkData.colors.inkColorObj) {
      this.isArtworkLoaded = true;
      delete this.data.selectedInkColorObj[this.data.active_artwork_loc]
      //delete this.data.inkChangeData[$scope.active_artwork_loc]
      delete this.data.selectedInkColor[this.data.active_artwork_loc]
      this.data.selectedInkColorObj[this.data.active_artwork_loc] = tmpartworkData.colors.inkColorObj;
      this.data.selectedInkColor[this.data.active_artwork_loc] = tmpartworkData.colors.inkColors;
      this.data.artworkHexColors[this.data.active_artwork_loc].img_ext_path = tmpartworkData.file_url;
      this.data.projects.projects_data[this.data.activeProjectIndex]["inkColorObj"] = this.data.selectedInkColorObj;
      this.data.projects.projects_data[this.data.activeProjectIndex]["inkColors"] = this.data.selectedInkColor;
    }
    this.data.url = JSON.parse(JSON.stringify(imageUrl));
    this.displayCanvasImage(imageUrl, '', '', 0);
  }

  showInvoiceArtwork = function (imgName) {
    let imgExt = imgName.split(".").pop().toLowerCase();
    if (['ai', 'eps', 'pdf', 'AI', 'EPS', 'PDF', 'cdr'].indexOf(imgExt) >= 0) {
      return 'assets/img/' + imgExt + '.png';
    }
    else {
      return imgName;
    }
  }

  showCdrFile(urlname) {
    let urlExt = urlname.split('.').pop().toLowerCase();
    if (['cdr'].indexOf(urlExt) >= 0) {
      return 'assets/img/' + urlExt + '.png';
    }
    else {
      return urlname;
    }


  }

  backToArtworkData() {
    this.artworkFiles = [];
  }

  deleteFile = function (file_name, artwork_img, artwork_id) {
    let fd = new FormData();
    fd.append("id", localStorage.getItem("userID"));
    fd.append("img_name", file_name);
    fd.append("artwork_img", ((artwork_img) ? artwork_img : ''));
    fd.append("actionType", "deleteFile");
    fd.append("artwork_id", artwork_id);

    this.CommonService.apiService(
      "POST",
      "artwork/delete",
      fd
    ).subscribe(
      (response: any) => {
        if (response.status === true) {

        }
      },
      err => {
        console.log('Error', err.error.message);
      }
    );
  }

  changeMatrix(loc, matrixId) {

    let selectedPlacement = this.data.otherPrintSettings[loc].placementIndex;
    this.data.otherPrintSettings[loc].priceMatrix = JSON.parse(JSON.stringify(this.data.artworkPrintOpt[loc].locationSetting[selectedPlacement]['printPositions'][0].matrixData.find(x => x.matrix_id == matrixId)));
    this.data.inkColors = this.data.artworkPrintOpt[loc].locationSetting[selectedPlacement]['printPositions'][0].matrixData.find(x => x.matrix_id == matrixId).inks;

  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/pf-artfile/pf-artfile.component.ts